<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <EnterprieSidebarMenu :show_menu="false" :show_back_button="true" back_link="enterpriseadminreports"></EnterprieSidebarMenu>
      <div class="content-wrapper padding-left-165">
        <div class="container-wrapper center ml-2">
        <div class="rep_audit_bg">



          <div >
          
          <div class="row mt-3 mb-3 border-bottom pb-2">
            <div class="col pl-0">
              <div class="h4 text-uppercase">Usage Report</div>
            </div>
            <div class="col">
              <div v-if="results.length > 0" class="margin-t-2 float-right pl-2" @click="shareButtonModal()">
                <img class="cursor-pointer" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" />
              </div>

              <div v-if="results.length > 0" class="margin-t-2 float-right pl-2 mr-2" @click="exportCSVAction()">
                <img v-if="results.length > 0"  class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" />
              </div>
            </div>
          </div>


          <div class="text-center pt-4" v-if="loading == true">
            <div class="row" v-for="option in 5">
              <div class="field_1 p-0"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_2 padding-l-15"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_3 padding-l-15"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_4 padding-l-15"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_5 padding-l-15"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_6 padding-l-15"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_7 padding-l-15"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_8 padding-l-15"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_9 padding-l-15"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>


          <div class="row report_heading" v-if="loading == false">
            <div class="field_1">No</div>
            <div class="field_2">Location Name</div>
            <div class="field_3 text-align-center">Number of Managers</div>
            <div class="field_4 text-align-center">Number of Mentors</div>
            <div class="field_5 text-align-center">Number of Mentees</div>
            <div class="field_6 text-align-center">Reps to Review</div>
            <div class="field_7 text-align-center">Reps Recorded</div>
            <div class="field_8 text-align-center">Competencies Earned</div>
            <div class="field_9 text-align-center">Inactive Mentees</div>
            <div class="col-12 p-0">
                <div class="custom_heading_hr"></div>
            </div>
          </div>

          <div class="row report_view" v-for="(result,rindex) in results" :key="rindex">
            <div class="field_1 " style="color: #000 !important;">{{ parseInt(rindex + 1) }}</div>
            <div class="field_2 branding_text_color" @click="openSidebar(result.accountId)">{{ result.accountName }}</div>
            <div class="field_3 text-align-center">{{ result.managerCount }}</div>
            <div class="field_4 text-align-center">{{ result.mentorCount }}</div>
            <div class="field_5 text-align-center">{{ result.menteeCount }}</div>
            <div class="field_6 text-align-center">{{ result.repsReviewCount }}</div>
            <div class="field_7 text-align-center">{{ result.repsAddedCount }}</div>
            <div class="field_8 text-align-center">{{ result.competencyEarnedCount }}</div>
            <div class="field_9 text-align-center">{{ result.inactivementeeCount }}</div>
            <div class="col-12 p-0">
                <div class="custom_hr"></div>
            </div>
          </div>

          <div class="row report_heading" v-if="loading == false">
            <div class="field_1">&nbsp;</div>
            <div class="field_2">Total</div>
            <div class="field_3 text-align-center">{{ totalManagerCount }}</div>
            <div class="field_4 text-align-center">{{ totalMentorCount }}</div>
            <div class="field_5 text-align-center">{{ totalMenteeCount }}</div>
            <div class="field_6 text-align-center">{{ totalRepsReviewCount }}</div>
            <div class="field_7 text-align-center">{{ totalRepsAddedCount }}</div>
            <div class="field_8 text-align-center">{{ totalCompetencyEarnedCount }}</div>
            <div class="field_9 text-align-center">{{ totalInactiveMenteeCount }}</div>
          </div>
          </div>

        </div>

        </div>


      </div>
    </div>


    <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading ml-1"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding success_msg">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control input-height-35"
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div class="clear margin-bottom-10"></div>


        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn col-3 input-height-25 ma-blue-btn"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey input-height-25 col-lg-3"
              ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>


      <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"></div>
        <div slot="body">
          <div class="">
            <div class="export-details">
              Exported: {{ rowsExportedCSV }} of {{ rowsCSV}}
            </div>
            <div class="percentage-text">
              {{ percentage }}
            </div>
            <div class="batch-box">
              <div class="batch-loading" id="batch-loading" >
                &nbsp;
              </div>
            </div>
            <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
              Download CSV File
            </div>
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </BatchModal>

      <EnterpriseAdminOverlaySidebar
          :isModalVisible="isLocationModalVisible" 
          @close="closeSidebar"
          ref="location_sidebar" 
          :readOnly="isReadOnly" 
      />

  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterprieSidebarMenu from '@/components/shared/enterpriseadmin_sidebar_menu.vue';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';
import VeeValidate from 'vee-validate';
import BatchModal from '../admin/reports/report_loading_modal.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    data() {
        return {
            loading: false,
            showOverlay: false,
            results: [],
            totalManagerCount: 0,
            totalMentorCount: 0,
            totalMenteeCount: 0,
            totalRepsReviewCount: 0,
            totalRepsAddedCount: 0,
            totalCompetencyEarnedCount: 0,
            totalInactiveMenteeCount: 0,
            apiUrl: '',
            isModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            showOverlay: false,
            showWait: false,
            showShareSuccess: false,
            isExportModalVisible: false,
            percentage: '0%',
            fileName: '',
            totalCSVPages: 0,
            perCSVPage: 500,
            rowsCSV: 0,
            rowsExportedCSV: 0,
            currentCSVPage: 1,
            isLocationModalVisible: false,
        }
    },
    components: {
        UserMenu,
        EnterprieSidebarMenu,
        ShareReportModal,
        EnterpriseAdminOverlaySidebar,
        BatchModal,
    },
    computed: {
      isReadOnly(){
        if (this.$store.state.enterprise_type === 'Readonly') {
          return true;
        } else {
          if (this.$store.state.switch_admin_enterprise_isreadonly) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    methods: {
        openSidebar(accountId) {
            this.isLocationModalVisible = true;
            this.$refs.location_sidebar.getLocationDetail(accountId);
        },
        closeSidebar() {
            this.isLocationModalVisible = false;
            this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
        },
        goToLocationWindow() {
          router.push('/enterprise-admin-dashboard');
        },
        shareButtonSubmit: function() {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              this.submit_text = 'Please wait...';
              this.showWait = true;
              this.currentCSVPage = 1;
              this.rowsCSV = 0;
              this.rowsExportedCSV = 0;
              this.totalCSVPages = 0;
              this.percentage = 0;
              this.fileName = '';
              this.showWait = true;

              axios('/enterprise-admin/share-usage-report',              
              {
                  method: 'POST',
                  data: {            
                    email: this.share_email,
                  },
                })

              .then((resp) => {
                this.share_email = '';
                this.submit_text = 'Submit';
                this.share_button_disable = true;
                this.showWait = false;
                this.showShareSuccess = true;
                setTimeout(() => {
                    this.showShareSuccess = false;
                }, 5000)

               })
              .catch(error => {

              });
            }
          });
        },

        shareButtonModal() {
          this.isModalVisible = true;
        },

        downloadFunc: function() {
          var url = this.apiUrl + '/custom/csv-view/' + this.fileName + '/Usage';
          window.location.href = url;
          this.isExportModalVisible = false;
          return false;
        },
        exportCSVAction: function() {
          this.isExportModalVisible = false;
          this.currentCSVPage = 1;
          this.rowsCSV = 0;
          this.rowsExportedCSV = 0;
          this.totalCSVPages = 0;
          this.percentage = 0;
          this.fileName = '';
          this.fetchUsageListCSV();
        },
        fetchUsageListCSV: function() {

          axios.get('/enterprise-admin/usage-report-csv', {
          })
          .then(response =>  {

              this.isExportModalVisible = true;
              this.currentCSVPage = response.data.page;
              this.rowsCSV = response.data.total_rows;
              this.rowsExportedCSV = response.data.total_rows_exported;
              this.totalCSVPages = response.data.total_pages;
              this.percentage = response.data.percentage;
              this.fileName = response.data.file_name;
              document.getElementById("batch-loading").style.width = this.percentage;
              if(this.currentCSVPage <= this.totalCSVPages) {
                this.fetchUsageListCSV();
              }

          })
          .catch(function(error) {
            console.log(error);
          });
        },



        fetchIUsersListitems() {
          this.loading = true;
          axios.get('/enterprise-admin/account_usage_report')
          .then(response =>  {
              this.loading = false;
              this.results = response.data.data;
              this.totalManagerCount = response.data.totalManagerCount;
              this.totalMentorCount = response.data.totalMentorCount;
              this.totalMenteeCount = response.data.totalMenteeCount;
              this.totalRepsReviewCount = response.data.totalRepsReviewCount;
              this.totalRepsAddedCount = response.data.totalRepsAddedCount;
              this.totalCompetencyEarnedCount = response.data.totalCompetencyEarnedCount;
              this.totalInactiveMenteeCount = response.data.totalInactiveMenteeCount;
          })
          .catch(function(error) {
              console.log(error);
          });
        },
    },
    created() {
      this.apiUrl = process.env.API_ENDPOINT;
      this.fetchIUsersListitems();
    }
}
</script>
<style scoped>
.modal-goback { font-size: 22px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.rep_audit_bg {
    background-color: #FFF;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 10px;
}
.rep_heading {    
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
}
.report_heading {   
    font-size: 14px; 
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: bold;
}
.custom_heading_hr, .custom_hr {
  width: 100%;
  margin: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom_heading_hr {
    border-bottom: 3px solid #A3A3A3;
}
.field_1 {
  width: 5%;
  padding-left: 0px;
}
.field_3, .field_4, .field_5, .field_6, .field_7, .field_8, .field_9 {
  width: 11%;
}
.field_9 {
  padding-right: 15px;
}
.field_2 {
  width: 18%;
}
.report_view .field_2 {
  cursor: pointer;
}
.circle {
  background-color: #2EACEE;  
  border-radius: 50%;
  height: 36px;
  width: 36px;
  text-align: center;
}
.circle i {
  color: #FFF;  
  font-size: 24px;
  text-align: center;
  padding-top: 5px;
  padding-right: 2px;
}
.print-section {
    font-family: "proxima-nova",sans-serif;
    color: #002F42;
}
.btn-dard-grey {
  border-radius: 15px;  
}
.success_msg {
  color: #68C47E; text-align: center; margin-bottom: 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/enterpriseadmin/usage_report.vue